import React from 'react';
//@ts-ignore
import * as layoutStyle from "../styles/layout.module.scss";
import "../styles/global.scss";
import { GoUp } from "./SVG/goUp";
import { Linkedin, Github, Codepen } from "./SVG/socialNetwork";
import { Header } from './Header';
const { useState } = React;

export const Layout = ({ children, visibleNav }) => {
    const [openMenu, setOpenMenu] = useState(false);

    const handleClick = () => setOpenMenu(prev => !prev);
    return (
        <>
            <Header />
            <nav className={`${layoutStyle.navBar} ${visibleNav ? `${layoutStyle.visible}` : ""}`}>
                <div className={layoutStyle.logo}>
                </div>
                <div className={`${layoutStyle.rightBlock} ${openMenu ? layoutStyle.activeMenu : ""}`}>
                    <ul>
                        <li><a href="#home">Home</a></li>
                        <li><a href="#works">Works</a></li>
                        <li><a href="#about">About</a></li>
                        <li><a href="#contact">Contact</a></li>
                    </ul>
                </div>
                <button onClick={handleClick} className={`${layoutStyle.burgerMenu} ${openMenu ? layoutStyle.active : ""}`} id="toggler">
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </nav>
            {children}
            <footer className={layoutStyle.footerSection}>
                <a href="#home" >
                    <button className={`${layoutStyle.goUpBtn}`}>
                        <GoUp className={layoutStyle.goUp} />
                    </button>
                </a>
                <div className={layoutStyle.networkBlock}>
                    <a href="https://www.linkedin.com/in/kevin-cheng-wu/" target="_blank" className={layoutStyle.networkBtn}>
                        <Linkedin className={layoutStyle.networkSVG} />
                    </a>
                    <a href="https://github.com/Kev2000-Github" target="_blank" className={layoutStyle.networkBtn}>
                        <Github className={layoutStyle.networkSVG} />
                    </a>
                    <a href="https://codepen.io/kev2000-github" target="_blank" className={layoutStyle.networkBtn}>
                        <Codepen className={layoutStyle.networkSVG} />
                    </a>
                </div>
                <p className={layoutStyle.creator}>KEVIN CHENG <span>©2020</span></p>
            </footer>
        </>
    )
}